import { Component, OnInit, ViewChild } from '@angular/core';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EbwModalService } from 'src/app/library/ebw-modals-angular/ebw-modal.service';
import { EBWModalResult } from 'src/app/library/ebw-modals-angular/model/ebw-modal.model';
import { AnalysisDataAccessService } from 'src/app/servizi/analysis/analysis-data-access.service';
import { GroupsHandlerService } from 'src/app/servizi/groups-handler.service';
import { GestioneUtentiService } from 'src/app/servizi/utenti/gestione-utenti.service';

@Component({
  selector: 'app-analysis-modal-associa',
  templateUrl: './analysis-modal-associa.component.html',
  styleUrls: ['./analysis-modal-associa.component.scss']
})
export class AnalysisModalAssociaComponent implements OnInit {
  
  selectedGroup = -1;

  // Icone
  faTrash = faTrash;

  // Lista Gruppi disponibili
  groupsList: any;

  // Lista Gruppi Associati
  linkedGroupsIds: number[] = [];
  linkedGroupsObj: any[] = [];

  // ID delle analisi passati in input
  analysisIds: number[];

  public edited = false;

  constructor(
    public modal: NgbActiveModal,
    private _ebwModalService: EbwModalService,
    private groupService: GroupsHandlerService,
    private analysisDataAccessService: AnalysisDataAccessService) { }

  ngOnInit(): void {

    this.getGroups();
  }

  /** Lista Gruppi disponibili */
  getGroups() {
    this.groupService.groupList().subscribe({
      next: (res) => {
        // to do check if error
        if (res && res.data && res.data.length > 0) {
          this.groupsList = res.data.map(x => x.properties);
        }
      },
    })
  }

  /** Selezione Gruppo */ 
  onChange(groupId: number){

    let group = this.groupsList.filter(el => el.id == groupId);
    if(!!group && group.length > 0){
      
      if(!this.linkedGroupsIds.includes(group[0].id)){
        this.linkedGroupsIds.push(group[0].id);
        this.linkedGroupsObj.push(group[0]);
      }
    }
    setTimeout(() => this.selectedGroup = -1, 0);
  }

  /** Rimuovi gruppo dalla lista */
  removeGroup(index: number, groupId: number){

    this.linkedGroupsIds.splice(index, 1);

    let i = this.linkedGroupsObj.findIndex(el => el.id === groupId);

    if(i >= 0){
      this.linkedGroupsObj.splice(i, 1);
    }
  }

  onSubmit(){

    // TODO cosa succede se non seleziono alcun gruppo? Vengono eliminate tutte le relazioni?
    let content;
    let title;

    if(this.analysisIds.length > 1){
      title ="Associazione Gruppi Massiva";
      content = "L'operazione comporterà l'associazione massiva dei gruppi alle analisi selezionate. Continuare?";
    } else {
      title ="Associazione Gruppi";
      content = "L'operazione comporterà l'associazione dei gruppi all'analisi selezionata. Continuare?";
    }

    this._ebwModalService.openConfirmModal({
      title: title,
      content: content
    }).result.then(res => {
      if (res == EBWModalResult.Confirm) {
        this._linkGroupsAnalyses();
      }
    })
  }

  private _linkGroupsAnalyses(){
    /*
      Al click del bottone “Aggiorna” tutte le relazioni tra analisi 
      selezionate e gruppi vengono cancellate a favore di quelle presenti nella griglia al momento della conferma.
    */

    // Sostituito userId: this.gestioneUtentiService.userData.id con null
    // Non serve inserire lo userId nella relazione, basta che ci sia il gruppo affinchè l'analisi sia visibile all'utente loggato (in base al gruppo a cui appartiene)

    this.analysisDataAccessService.relAnalysesGroupMassiveUpdate({ analysisIds: this.analysisIds, groupIds: this.linkedGroupsIds }).subscribe({
      next: (res) => {
        if (!res || res.error !== 0) {
          this._ebwModalService.openErrorModal({
            title: "Errore",
            content: "Errore associazione gruppi: " + res.errorDescription
          });
        }
        this._ebwModalService.openSuccessModal({
          title: "Successo",
          content: "Gruppi associati con successo"
        });

        this.edited = true;
      },
      error: (error) => {
        this._ebwModalService.openErrorModal({
          title: "Errore",
          content: "Errore associazione gruppi"
        });
      }
    });
  }


}
